import { Avatar, Box, Button, Flex, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { createTopicPost, createWallPost, WallHeader, WallPost } from "@lubbezposrednio-frontend/core";
import { MentionTextarea, mediaUrl } from "./wallShared";

// ── Modal tworzenia posta (jak w fejsie). Reużywany na ścianie ORAZ w temacie forum (topicId). ──
export const CreatePostModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  groupName: string;
  onCreated: (p: WallPost) => void;
  groupId: string;
  me: WallHeader["me"];
  topicId?: string; // ustawione → post trafia do tematu forum (ten sam modal co na ścianie)
}> = ({ isOpen, onClose, groupName, onCreated, groupId, me, topicId }) => {
  const [body, setBody] = useState("");
  const [posting, setPosting] = useState(false);
  const toast = useToast();

  const submit = async () => {
    const value = body.trim();
    if (!value) return;
    setPosting(true);
    try {
      const { data } = topicId ? { data: await createTopicPost(groupId, topicId, value) } : await createWallPost(groupId, value);
      onCreated(data);
      setBody("");
      onClose();
    } catch {
      toast({ title: "Nie udało się opublikować", status: "error", isClosable: true });
    } finally {
      setPosting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
      <ModalOverlay bg="rgba(20,0,45,0.55)" backdropFilter="blur(3px)" />
      <ModalContent borderRadius="20px" overflow="hidden">
        <ModalHeader textAlign="center" borderBottom="1px solid rgba(67,0,152,0.08)" fontSize="17px" color="primary" fontWeight="800">
          {topicId ? "Nowy post w temacie" : "Utwórz post"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pt="18px">
          <HStack spacing="11px" mb="14px">
            <Avatar size="sm" boxSize="42px" name={me.name} src={mediaUrl(me.avatar_url)} bg="rgba(67,0,152,0.1)" color="primary" />
            <Box>
              <Text fontWeight="800" color="primary" fontSize="15px">{me.name}</Text>
              <Text fontSize="12px" color="gray.400">{topicId ? "Publikujesz w temacie" : `Publikujesz w grupie „${groupName}"`}</Text>
            </Box>
          </HStack>
          <MentionTextarea
            groupId={groupId}
            autoFocus
            value={body}
            onChange={setBody}
            placeholder={topicId ? "Napisz post w temacie… (@ aby wspomnieć)" : `Co słychać w grupie „${groupName}"? (@ aby wspomnieć)`}
            minH="150px"
            border="none"
            fontSize="17px"
            p="0"
            _focusVisible={{ boxShadow: "none" }}
            maxLength={5000}
          />
        </ModalBody>
        <ModalFooter flexDir="column" alignItems="stretch" gap="10px" borderTop="1px solid rgba(67,0,152,0.06)">
          <Flex justify="space-between" align="center" w="100%">
            <Text fontSize="12px" color="gray.400">{body.length}/5000</Text>
          </Flex>
          <Button onClick={submit} isLoading={posting} isDisabled={!body.trim()} w="100%" bg="primary" color="white" borderRadius="12px" fontWeight="800" size="lg" _hover={{ bg: "#360079" }}>
            Opublikuj
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
